var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlgarand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1766_7053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98186 21L10.2677 17.0556L12.5535 13.125L14.8254 9.18056L15.2018 8.55556L15.369 9.18056L16.0659 11.7778L15.2854 13.125L12.9996 17.0556L10.7277 21H13.4595L15.7454 17.0556L16.9301 15.0139L17.4876 17.0556L18.5469 21H21L19.9407 17.0556L18.8814 13.125L18.6027 12.1111L20.3031 9.18056H17.8221L17.7385 8.88889L16.8743 5.66667L16.7628 5.25H14.3794L14.3237 5.33333L12.0936 9.18056L9.80774 13.125L7.53584 17.0556L5.25 21H7.98186Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1766_7053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.625,
    height: 16.625,
    fill: "white",
    transform: "translate(5.25 4.375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgarand);
export default __webpack_public_path__ + "static/media/algarand.dc8301c632d1b84812710280cb97039e.svg";
export { ForwardRef as ReactComponent };